// filterUtils.ts

export const getLocationIds = (checkedValue: any) =>
    Object.keys(checkedValue["location"] || {}).map(
      (key) => checkedValue["location"]?.[key]?.id ?? 0
    );
  
  export const getMembershipIds = (checkedValue: any) =>
    checkedValue["membershipName"]
      ? Object.keys(checkedValue["membershipName"])
          .map((key) => checkedValue["membershipName"]?.[key]?.id)
          .filter((id): id is number => id !== undefined)
      : [];
  
  export const getIsMobNoVerify = (checkedValue: any) =>
    checkedValue["isMobNoVerify"]
      ? Object.keys(checkedValue["isMobNoVerify"])
          .map((key) => checkedValue["isMobNoVerify"]?.[key]?.value)
          .join(", ")
      : "";
  
  export const getCityIds = (checkedValue: any) =>
    checkedValue["cityName"]
      ? Object.keys(checkedValue["cityName"])
          .map((key) => checkedValue["cityName"]?.[key]?.city_id)
          .filter((id): id is number => id !== undefined)
      : [];

     export const getStateIds = (checkedValue: any) =>
    checkedValue["stateName"]
      ? Object.keys(checkedValue["stateName"])
          .map((key) => checkedValue["stateName"]?.[key]?.state_id)
          .filter((id): id is number => id !== undefined)
      : [];
      
        export const getCountryIds = (checkedValue: any) =>
    checkedValue["countryName"]
      ? Object.keys(checkedValue["countryName"])
          .map((key) => checkedValue["countryName"]?.[key]?.country_id)
          .filter((id): id is number => id !== undefined)
      : [];
  
  export const getPinCodes = (checkedValue: any) =>
    checkedValue["pinCode"]
      ? Object.keys(checkedValue["pinCode"]).map(
          (key) => checkedValue["pinCode"]?.[key]?.pin_code ?? ""
        )
      : [];
  
  export const getCreatedByIds = (checkedValue: any) =>
    checkedValue["createdByName"]
      ? Object.keys(checkedValue["createdByName"])
          .map((key) => checkedValue["createdByName"]?.[key]?.userid)
          .filter((id): id is number => id !== undefined)
      : [];
  
  export const getActiveStatus = (checkedValue: any) =>
    checkedValue["active"]
      ? Object.keys(checkedValue["active"])
          .map((key) => checkedValue["active"]?.[key]?.value)
          .join(", ")
      : "";
  
  export const getContactTypes = (checkedValue: any) =>
    checkedValue["contactType"]
      ? Object.keys(checkedValue["contactType"])
          .map((key) => checkedValue["contactType"]?.[key]?.value)
          .filter((value): value is string => value !== undefined)
      : [];
  